<div class="keywords-container">
  <div class="page-header">
    <h2>
      <mat-icon>label</mat-icon>
      Keywords
    </h2>
    <p>
      Verwalten Sie Keywords und ihre Werte. Keywords werden für Kategorisierung, Benutzerrollen und
      E-Mail-Benachrichtigungen verwendet.
    </p>
  </div>

  <div class="action-bar">
    <div class="search-box">
      <mat-icon>search</mat-icon>
      <input
        type="text"
        placeholder="Keywords durchsuchen..."
        [(ngModel)]="searchTerm"
        (input)="applyFilter()" />
    </div>
    <button
      mat-raised-button
      color="primary"
      (click)="btnAddNewKeyword()">
      <mat-icon>add</mat-icon>
      Neues Keyword
    </button>
  </div>

  <div class="keywords-grid">
    @for (keyword of filteredKeywords; track keyword.id) {
    <div
      class="keyword-card"
      (click)="btnEditKeyword(keyword)">
      <div class="card-header">
        <div class="keyword-icon">
          <mat-icon>label</mat-icon>
        </div>
        <div class="keyword-title">
          <h3>{{ keyword.keywordName }}</h3>
          <span class="value-count">
            <mat-icon>list</mat-icon>
            {{ keyword.keywordValues.length || 0 }} Wert(e)
          </span>
        </div>
      </div>

      @if (keyword.keywordValues && keyword.keywordValues.length > 0) {
      <div class="card-content">
        <div class="values-preview">
          @for (value of keyword.keywordValues.slice(0, 3); track value.keywordValueName) {
          <div class="value-chip">
            <span class="value-name">{{ value.keywordValueName }}</span>
            @if (value.description) {
            <span class="value-description">{{ value.description }}</span>
            }
          </div>
          } @if (keyword.keywordValues.length > 3) {
          <div class="more-values">+{{ keyword.keywordValues.length - 3 }} weitere</div>
          }
        </div>
      </div>
      } @else {
      <div class="card-content empty">
        <mat-icon>info_outline</mat-icon>
        <span>Keine Werte definiert</span>
      </div>
      }

      <div class="card-actions">
        <button
          mat-icon-button
          (click)="btnEditKeyword(keyword); $event.stopPropagation()"
          matTooltip="Bearbeiten">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </div>
    }
  </div>

  @if (filteredKeywords.length === 0 && searchTerm) {
  <div class="no-results">
    <mat-icon>search_off</mat-icon>
    <h3>Keine Keywords gefunden</h3>
    <p>Versuchen Sie einen anderen Suchbegriff</p>
  </div>
  }
</div>
